import { render, staticRenderFns } from "./BookDetail.vue?vue&type=template&id=0da75c24"
import script from "../../controllers/book_library/book-detail.js?vue&type=script&lang=js&external"
export * from "../../controllers/book_library/book-detail.js?vue&type=script&lang=js&external"
import style0 from "./BookDetail.vue?vue&type=style&index=0&id=0da75c24&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports